var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isUserLoggedIn && _vm.$route.name !== 'Login')?_c('Appbar'):_vm._e(),_c('AppProgressCircular'),_c('AppSnackbar'),_c('v-main',[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }